var map = {
	"./代脉.gif": 8842,
	"./伏脉.gif": 4166,
	"./促脉.gif": 2122,
	"./动脉.gif": 7943,
	"./实脉.gif": 193,
	"./平脉.gif": 4970,
	"./弦脉.gif": 5193,
	"./弱脉.gif": 4164,
	"./微脉.gif": 3361,
	"./散脉.gif": 8762,
	"./数脉.gif": 8543,
	"./沉脉.gif": 3228,
	"./洪脉.gif": 6029,
	"./浮脉.gif": 497,
	"./涩脉.gif": 3260,
	"./滑脉.gif": 308,
	"./濡脉.gif": 3236,
	"./牢脉.gif": 4005,
	"./疾脉.gif": 5073,
	"./短脉.gif": 8592,
	"./紧脉.gif": 7566,
	"./细脉.gif": 2121,
	"./结脉.gif": 2746,
	"./缓脉.gif": 8602,
	"./芤脉.gif": 8835,
	"./虚脉.gif": 9709,
	"./迟脉.gif": 3942,
	"./长脉.gif": 7654,
	"./革脉.gif": 7628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2022;